import React, { useRef } from 'react';
const SwipeableComponent = ({ className, children, onSwipeLeft, onSwipeRight }) => {
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);
    const handleTouchStart = (ev) => {
        touchStartX.current = ev.touches[0].clientX;
    };
    const handleTouchMove = (ev) => {
        touchEndX.current = ev.touches[0].clientX;
    };
    const handleTouchEnd = () => {
        const deltaX = touchStartX.current - touchEndX.current;
        if (deltaX > 50) {
            onSwipeLeft && onSwipeLeft();
        }
        else if (deltaX < -50) {
            onSwipeRight && onSwipeRight();
        }
    };
    return (React.createElement("div", { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, className: className }, children));
};
export default SwipeableComponent;
